import {inspectionApiClient} from 'src/api/ProactApiClientInstances';
import {registerInspectionOffline} from 'src/app/inspections/offline/registerInspectionOffline';

// Composition root for inspection offline replay: binds the API client to the
// domain registration in src/app, which may not import the client itself.
registerInspectionOffline(inspectionApiClient);
